import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description:
      "TekRevol is a high-end Android app development company in Houston that excels in creating Native Android Apps that fully harness the capabilities of the world's most widely used mobile platform. Through a dynamic tech stack of Java or Kotlin and the latest app development frameworks, we bring your app ideas to life with precision and innovation.",
  },
  {
    icon: IphoneIcon,
    title: "iPhone app development",
    description: (
      <>
        Experience the epitome of sophistication with TekRevol's{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          Native iOS App Development services
        </Link>
        .Our skilled iOS developers are dedicated to creating apps that
        epitomize the elegance and seamless functionality that iOS users expect.
        With a focus on user experience and technical excellence, our Native iOS
        apps offer your audience an unparalleled journey through your brand's
        world.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description:
      "We can bring your game idea to life with our efficient game app development services in Houston. TekRevol creates stunning games with high-quality graphics and deep programming along with a seamless experience for players. Having proficiency in many genres like shooting, arcade, RPG, and strategy, you can develop any kind of game with us.",
  },
  {
    icon: FlutterIcon,
    title: "Flutter App Development",
    description: (
      <>
        You can get feature-rich applications using our{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter app development services
        </Link>
        . TekRevol has the expertise to deliver efficient digital solutions for
        Android and iOS using Flutter. This will be an amazing opportunity for
        you to scale your business to a new level as we have already worked on
        100+ Flutter projects.
      </>
    ),
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare App Development",
    description:
      "TekRevol can develop versatile healthcare applications combining their expertise and innovation. So, if you want to streamline the complex processes of your healthcare business, TekRevol is the way to go! We create apps that assist our clients to stand out in the market by delivering efficiency in the processes.",
  },
  {
    icon: ReactIcon,
    title: "React Native App Development",
    description:
      "TekRevol utilizes the power of React Native to construct robust mobile applications for both Android and iOS platforms, ensuring extensive functionality and delivering seamless performance. Our skilled team builds apps meeting your needs, ensuring consistent quality across devices and systems.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>TekRevol’s Mobile App Developers Services in Houston</h2>
            <p className="impro_para">
              {" "}
              You can consider us as your innovation partner rather than just a
              mobile app development company in Houston. TekRevol offers
              unparalleled app development services in Houston based on a
              dynamic landscape where cutting-edge technology intersects with
              innovative solutions. Your app isn't just another project to us;
              it's a journey toward helping your business thrive in the digital
              landscape.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
